import ServiceCenters from './ServiceCenters.redux';

export default ServiceCenters;
